import * as faceapi from 'face-api.js';

faceapi.loadTinyFaceDetectorModel('/faceapi/models');

let faceApiActive = true;
let faceApiScore = 0.8;
let faceApiBoxHeight = 160;
let faceApiBoxWidth = 160;

const detectSingleFace = async function(canvasElement){
  return faceapi.detectSingleFace(canvasElement, new faceapi.TinyFaceDetectorOptions());
}

const validate = async function(canvasElement, photoScore, boxHeight, boxWidth){

  faceApiScore = (photoScore === undefined ? faceApiScore : photoScore);
  faceApiBoxHeight = (boxHeight === undefined ? faceApiBoxHeight : boxHeight);
  faceApiBoxWidth = (boxWidth === undefined ? faceApiBoxWidth : boxWidth);

  if(!faceApiActive){
    return true;
  }

  try {
    const result = await detectSingleFace(canvasElement);
    console.log(result);

    if (!result || !result._score || result._score < faceApiScore) {
      return false;
    }

    if (result._box._width < faceApiBoxWidth || result._box._height < faceApiBoxHeight) {
      return false;
    }

  } catch (e) {
    console.error(e);
    return false;
  }

  return true;

}

export default {
  validate
}